export * from './auth';

export function getAvatarInitial(firstName: string, lastName: string): string {
  if (!firstName || !lastName) return '';

  const initials = [firstName, lastName].map((part) => part[0].toUpperCase());
  return initials.join('');
}
